// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlertMessage_AlertMessage__KX8Kb {
  flex: 1 1;
  min-width: 0;
  height: 426px;
  border-radius: 30px;
  box-sizing: border-box;
  padding: 24px 28px;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  overflow-wrap: anywhere;
}

.AlertMessage_default__cgGbD {
  background: #ff735c;
}

.AlertMessage_red__86Txb {
  background: #ff735c;
}

.AlertMessage_yellow__IHAus {
  background: #ffda65;
}

.AlertMessage_heading__1kgsC {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 18px;
}
.AlertMessage_heading__1kgsC svg {
  flex-shrink: 0;
  width: 78px;
  height: 78px;
}
.AlertMessage_heading__1kgsC h2 {
  margin: 0;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.AlertMessage_primaryLevel__WydXt {
  flex-shrink: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
}

.AlertMessage_compactHeading__twWkD h2 {
  font-size: 22px;
}

.AlertMessage_instruction__DAhTg {
  flex-shrink: 0;
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.25;
  text-transform: uppercase;
}

.AlertMessage_detail__oF20P {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  padding-top: 12px;
}

.AlertMessage_detailHeader__WaWPX {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  font-size: 20px;
  line-height: 1.3;
}

.AlertMessage_levelBadge__JIYts {
  border: 2px solid currentColor;
  border-radius: 20px;
  padding: 4px 12px;
  font-weight: 700;
}
.AlertMessage_levelBadge__JIYts.AlertMessage_default__cgGbD {
  background: rgba(255, 255, 255, 0.6);
}

.AlertMessage_counter__1mvAQ {
  margin-left: auto;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.AlertMessage_reasonViewport__O6FdR {
  flex: 1 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

.AlertMessage_reason__QpKlv {
  margin: 0;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.3;
}

.AlertMessage_measure__ObFGH {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  visibility: hidden;
}

.AlertMessage_pageCounter__tXbQR {
  flex: 0 0 22px;
  font-size: 18px;
  line-height: 22px;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/components/AlertMessage/AlertMessage.module.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAAR;;AAIA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,cAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wCAAA;EACA,iBAAA;AADJ;;AAIA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAIA;EACI,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AADJ;AAGI;EACI,oCAAA;AADR;;AAKA;EACI,iBAAA;EACA,mBAAA;EACA,kCAAA;AAFJ;;AAKA;EACI,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAFJ","sourcesContent":[".AlertMessage {\n    flex: 1;\n    min-width: 0;\n    height: 426px;\n    border-radius: 30px;\n    box-sizing: border-box;\n    padding: 24px 28px;\n    color: #000;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 12px;\n    overflow-wrap: anywhere;\n}\n\n.default {\n    background: #ff735c;\n}\n\n.red {\n    background: #ff735c;\n}\n\n.yellow {\n    background: #ffda65;\n}\n\n.heading {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 18px;\n\n    svg {\n        flex-shrink: 0;\n        width: 78px;\n        height: 78px;\n    }\n\n    h2 {\n        margin: 0;\n        font-size: 34px;\n        font-weight: 700;\n        line-height: 1.2;\n        text-transform: uppercase;\n    }\n}\n\n.primaryLevel {\n    flex-shrink: 0;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.compactHeading h2 {\n    font-size: 22px;\n}\n\n.instruction {\n    flex-shrink: 0;\n    margin: 0;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.25;\n    text-transform: uppercase;\n}\n\n.detail {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    border-top: 2px solid #0003;\n    padding-top: 12px;\n}\n\n.detailHeader {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px 12px;\n    font-size: 20px;\n    line-height: 1.3;\n}\n\n.levelBadge {\n    border: 2px solid currentColor;\n    border-radius: 20px;\n    padding: 4px 12px;\n    font-weight: 700;\n\n    &.default {\n        background: #fff9;\n    }\n}\n\n.counter {\n    margin-left: auto;\n    white-space: nowrap;\n    font-variant-numeric: tabular-nums;\n}\n\n.reasonViewport {\n    flex: 1;\n    min-height: 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.reason {\n    margin: 0;\n    font-size: 26px;\n    font-weight: 500;\n    line-height: 1.3;\n}\n\n.measure {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    visibility: hidden;\n}\n\n.pageCounter {\n    flex: 0 0 22px;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AlertMessage": `AlertMessage_AlertMessage__KX8Kb`,
	"default": `AlertMessage_default__cgGbD`,
	"red": `AlertMessage_red__86Txb`,
	"yellow": `AlertMessage_yellow__IHAus`,
	"heading": `AlertMessage_heading__1kgsC`,
	"primaryLevel": `AlertMessage_primaryLevel__WydXt`,
	"compactHeading": `AlertMessage_compactHeading__twWkD`,
	"instruction": `AlertMessage_instruction__DAhTg`,
	"detail": `AlertMessage_detail__oF20P`,
	"detailHeader": `AlertMessage_detailHeader__WaWPX`,
	"levelBadge": `AlertMessage_levelBadge__JIYts`,
	"counter": `AlertMessage_counter__1mvAQ`,
	"reasonViewport": `AlertMessage_reasonViewport__O6FdR`,
	"reason": `AlertMessage_reason__QpKlv`,
	"measure": `AlertMessage_measure__ObFGH`,
	"pageCounter": `AlertMessage_pageCounter__tXbQR`
};
export default ___CSS_LOADER_EXPORT___;
